import Vue from "vue";

// App Store Setter
import AppStore from "@tenant/app/tabs/partials/appStore"
// import AppTitle from "@shared/components/Header";
import AppTitle from "@tenant/app/tabs/partials/appTitle";
import AppRouter from "@tenant/app/tabs/partials/appRouter"

// this will be removed once the site is completely using the new app store
import ApplicationRouter from "@shared/core/ApplicationRouter.vue";


import AzureLogin from "@shared/components/Auth/azureLogin.vue"
import ApplicationsComponent from "@shared/components/applications/ApplicationsComponent.vue"
import ApplicationsTableViewComponent from "@shared/components/applications/ApplicationsTableViewComponent.vue"
import ApplicationsKanbanBoardView from "@shared/components/applications/ApplicationsKanbanBoardView.vue"
import Row from "@shared/components/grid/Row.vue"
import Col from '@shared/components/grid/Col.vue'
import Panel from '@shared/components/panel/Panel.vue'
import Button from '@shared/components/button/Button.vue'
import ButtonGroup from '@shared/components/button/ButtonGroup.vue'
import Icon from '@shared/components/icon/Icon.vue'
import Sidebar from '@shared/components/sidebar/Sidebar.vue'
import SidebarItem from '@shared/components/sidebar/SidebarItem.vue'
import SidebarGroup from '@shared/components/sidebar/SidebarGroup.vue'
import FileManager from "@shared/components/fileManager/FileManager.vue";
import FileGroup from "@shared/components/fileManager/FileGroup.vue";
import DocumentPreview from "@shared/components/fileManager/DocumentPreview.vue";
import Loading from '@shared/components/helpers/Loading.vue'
import Width from '@shared/components/helpers/Width.vue'
import Tag from '@shared/components/tag/Tag.vue'
import Status from '@shared/components/tag/Status.vue'
import FieldTab from '@shared/components/tabs/FieldTab.vue'
import Input from '@shared/components/form/Input.vue'
import Textarea from '@shared/components/form/Textarea.vue'
import FormGroup from '@shared/components/form/FormGroup.vue'
import TagInput from '@shared/components/form/TagInput.vue'
import PlaceAutoComplete from "@shared/components/form/PlaceAutoComplete.vue";
import TypeaheadTable from '@shared/components/form/TypeaheadTable.vue'
import Select from '@shared/components/form/Select.vue'
import SimpleSelect from '@shared/components/form/SimpleSelect.vue'
import Switch from '@shared/components/form/Switch.vue'
import Alert from '@shared/components/alert/Alert.vue'
import Modal from '@shared/components/modal/Modal.vue'
import ModalNoDragOrResize from '@shared/components/modal/ModalNoDragOrResize.vue'
import CustomSignaturePad from '@shared/components/customSignaturePad/CustomSignaturePad.vue'
import NewTaskModal from '@shared/components/modal/NewTaskModal.vue'
import Dropdown from '@shared/components/dropdown/Dropdown.vue'
import DropdownMenu from '@shared/components/dropdown/DropdownMenu.vue'
import DropdownItem from '@shared/components/dropdown/DropdownItem.vue'
import DropdownLink from '@shared/components/dropdown/DropdownLink.vue'
import Typeahead from '@shared/components/form/Typeahead.vue'
import TypeaheadArray from '@shared/components/typeahead/TypeaheadArray.vue'
import TypeaheadUrl from '@shared/components/typeahead/TypeaheadUrl.vue'
import SlimCropper from "@shared/components/slim/slim.vue";
import SlimMulti from "@shared/components/slim/slimMulti.vue";
import SlimAttachments from "@shared/components/slim/slimAttachments.vue";
import SlimProfile from "@shared/components/slim/slimProfile.vue"
import FileUpload from "@shared/components/slim/FileUpload.vue";
import Image from '@shared/components/upload/Image.vue'
import HostsTable from "@shared/components/table/HostsTable.vue"
import Table from '@shared/components/table/Table.vue'
import TableRow from '@shared/components/table/TableRow.vue'
import TableHead from '@shared/components/table/TableHead.vue'
import TableBody from '@shared/components/table/TableBody.vue'
import TableCell from '@shared/components/table/TableCell.vue'
import TableFooter from '@shared/components/table/TableFooter.vue'
import SimpleTab from '@shared/components/tabs/SimpleTab.vue'
import Filterable from '@shared/components/filterable/Filterable.vue'
import Group from '@shared/components/helpers/Group.vue'
import Mini from '@shared/components/filterable/Mini.vue'
import Pagination from "@shared/components/pagination";
import PDFViewer from '@shared/components/pdf/PDFViewer.vue'
import PDFDataCustom from "@shared/components/pdf/PDFDataCustom.vue";
import PDFDocumentShow from "@shared/components/pdf/PDFDocumentShow.vue";
import CollapsibleSection from "@shared/components/CollapsibleSection";
import NiceModal from "@shared/components/NiceModal";
import Hems from "@shared/components/hems/Hems.vue";
import Form from '@shared/partials/Form.vue'
import Import from '@shared/partials/Import.vue'
import FooterToolbar from "@shared/components/toolbar/FooterToolbar.vue";
import Player from "@shared/components/player/Player.vue";

import AddressLookup from "@shared/components/AddressLookup"
import SendSettlementAdvice from "@shared/components/SendSettlementAdvice"
import DocumentPicker from "@shared/components/DocumentPicker"

import UserProfileSettings from "@shared/components/profile/UserProfileSettings.vue"

import ZapierTabs from "@shared/components/Zapier/ZapierTabs"

import XeroMain from "@shared/components/Xero/Main"
import VideoChat from "@shared/components/video/VideoChat"

// actions
import LoadingBar from '@shared/components/loading-bar'
import Message from '@shared/components/message'
import Http from '@shared/lib/Http'
import Master from "@shared/lib/Master"

import TenantSettingsTrigger from '@shared/components/Settings/TenantSettingsTrigger'
import TenantSettingsModal from '@shared/components/Settings/TenantSettingsModal'

import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from "@fortawesome/vue-fontawesome";
import {Multipane, MultipaneResizer} from "vue-multipane";
import VueDropzone from "vue2-dropzone";
import LaravelVuePagination from "laravel-vue-pagination";
import {VPopover} from "v-tooltip";
import VueMonthlyPicker from "vue-monthly-picker";
import VueDraggableResizable from "vue-draggable-resizable";
import VuePrismEditor from "vue-prism-editor";
import VueFloatLabel from "vue-float-label";

import CallReports from "@shared/components/3cx/CallReports.vue";
import TenantCallReports from "@shared/components/3cx/TenantCallReports.vue"

import ambitionChat from "@shared/components/chat"
import VueIframe from "vue-iframes"
import referrerTable from "@shared/components/referrer/referrerTable"

import FormBuilder from "@shared/components/CustomFormBuilder/"


//Teams Components
import AmbitionTeams from "@shared/components/Teams/AmbitionTeams"
import TeamSwitcher from "@shared/components/Teams/TeamSwitcher"
import TeamSwitcherTrigger from "@shared/components/Teams/TeamSwitcherTrigger"
import UserTeamSelector from "@shared/components/Teams/UserTeamSelector"
import ReferrerTeamSelector from "@shared/components/Teams/ReferrerTeamSelector"

//Dashboard Layout
import DashboardLayout from "@admin/components/AdminDashboard/DashboardLayout"

import CommercialJourney from "@tenant/commercial-journey/"
import IdleAmbition from "@shared/components/IdleAmbition/IdleAmbition.vue"
import LeadManagement from "@shared/components/LeadManagement/LeadManagement.vue"
import LeadManagementSettings from "@shared/components/LeadManagement/LeadManagementSettings.vue"

import Commitments from "@shared/components/commercial/Commitments.vue"
import DebtServicing from "@shared/components/commercial/DebtServicing.vue"
import CommitmentSchedule from "@shared/components/commercial/CommitmentSchedule.vue"
import SupportNotifications from "@shared/components/Support/Notifications/Tenant"
import DigitalAncillariesSettings from "@shared/components/DigitalAncillaries/DigitalAncillariesSettings"

// Admin Dashboard
import AdminDashboardIndex from "@tenant/dashboard/components/Index.vue"
import DisplayMultipleDashboards from "@tenant/dashboard/components/DashboardViews/DisplayMultipleDashboards.vue"

//Security Components
import AmbitionSecurity from "@shared/components/Security/AmbitionSecurity"

import InsuranceDocuments from "@shared/components/insuranceDocuments/insuranceDocuments"

import DirectDebit from "@shared/components/DirectDebit/DirectDebit"

import AppTabCollapse from "@shared/components/appTabLayout/AppTabCollapse";
import AppTabCollapseItem from "@shared/components/appTabLayout/AppTabCollapseItem";
import OrganiseAppTabs from '@shared/components/appTabLayout/OrganiseAppTabs.vue';

import ProfilePage from '@shared/components/user/profilePage.vue';
import ReferrerStageNotifications from '@shared/components/referrer/referrerStageNotifications.vue';
import ComprehensiveInsuranceOptions from '@admin/components/comprehensiveInsurance/comprehensiveInsuranceOptions.vue';

import DateFormatter from '@shared/components/helpers/dateFormatter.vue';
import ApplicationsAccessLogs from '@shared/components/applications/applicationsAccessLogs.vue'

import DashboardEdit from '@shared/components/Dashboard/DashboardEdit'
import DashboardIndex from '@shared/components/Dashboard/index.vue'
import DashboardCreate from '@shared/components/Dashboard/DashboardCreate'

import MergedDashboardIndex from '@shared/components/Dashboard/MergedDashboards/index.vue'
// import FormComponent from "@shared/components/CustomFormBuilder/formComponent"

import FormBuilderConfig from '@shared/components/CustomFormBuilder/builder/formBuilderConfig'
import TicketIndex from '@shared/components/Ticket/index.vue'
import EditTicket from '@shared/components/Ticket/EditTicket.vue'
import CreateTicket from '@shared/components/Ticket/CreateTicket.vue'



const components = {
    AppStore,
    AppRouter,
    AzureLogin,
    ApplicationsComponent,
    ApplicationsKanbanBoardView,
    ApplicationsTableViewComponent,
    Row,
    Col,
    Panel,
    Button,
    ButtonGroup,
    Icon,
    Sidebar,
    SidebarItem,
    SidebarGroup,
    FileManager,
    FileGroup,
    DocumentPreview,
    Loading,
    Width,
    Tag,
    Input,
    Textarea,
    PlaceAutoComplete,
    FormGroup,
    TagInput,
    Select,
    SimpleSelect,
    Switch,
    Alert,
    Modal,
    CustomSignaturePad,
    NewTaskModal,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownLink,
    Typeahead,
    TypeaheadArray,
    TypeaheadUrl,
    TicketIndex,
    EditTicket,
    CreateTicket,
    SlimCropper,
    SlimMulti,
    SlimAttachments,
    SlimProfile,
    FileUpload,
    Image,
    HostsTable,
    Table,
    TableCell,
    TableHead,
    TableRow,
    TableBody,
    TableFooter,
    SimpleTab,
    Filterable,
    FieldTab,
    Form,
    Status,
    Group,
    TypeaheadTable,
    Mini,
    Hems,
    CollapsibleSection,
    NiceModal,
    AppTitle,
    Pagination,
    PDFViewer,
    PDFDocumentShow,
    PDFDataCustom,
    Import,
    FooterToolbar,
    VideoChat,
    Player,
    AddressLookup,
    SendSettlementAdvice,
    DocumentPicker,
    ApplicationRouter,
    FontAwesomeIcon,
    FontAwesomeLayers,
    FontAwesomeLayersText,
    VueDropzone,
    Multipane,
    MultipaneResizer,
    VPopover,
    VueMonthlyPicker,
    VueDraggableResizable,
    VueFloatLabel,
    CallReports,
    TenantCallReports,
    UserProfileSettings,
    VueIframe,
    AmbitionTeams,
    TeamSwitcher,
    TeamSwitcherTrigger,
    ZapierTabs,
    XeroMain,
    DashboardLayout,
    AdminDashboardIndex,
    DisplayMultipleDashboards,
    ...CommercialJourney,
    ...ambitionChat,
    IdleAmbition,
    LeadManagement,
    LeadManagementSettings,
    Commitments,
    DebtServicing,
    CommitmentSchedule,
    SupportNotifications,
    TenantSettingsTrigger,
    TenantSettingsModal,
    DashboardEdit,
    DashboardIndex,
    MergedDashboardIndex,
    DashboardCreate,
    AmbitionSecurity,
    DigitalAncillariesSettings,
    InsuranceDocuments,
    DirectDebit,
    UserTeamSelector,
    ReferrerTeamSelector,
    referrerTable,
    ModalNoDragOrResize,
    AppTabCollapse,
    AppTabCollapseItem,
    OrganiseAppTabs,
    ProfilePage,
    ReferrerStageNotifications,
    ComprehensiveInsuranceOptions,
    DateFormatter,
    ApplicationsAccessLogs,
    // FormComponent,

    FormBuilderConfig,
    ...FormBuilder,
}

const actions = {
    LoadingBar,
    Message,
    Http,
    Master
}


function install(Vue) {
    if (install.installed) return
    for (const item in components) {
        if (components[item].name) {
            Vue.component(components[item].name, components[item])
        }
    }

    Vue.prototype.$bar = LoadingBar
    Vue.prototype.$message = Message
    Vue.prototype.$tenant = Http
    Vue.prototype.$master = Master
    Vue.prototype.$admin = Master

    Vue.component("Pagination", LaravelVuePagination)
    Vue.component("prism-editor", VuePrismEditor)
}

if (Vue) {
    install(Vue)
}

export default {
    install,
    ...components,
    ...actions
}
